import { TreeNode } from '../route-builder';

export const HomePageModule = { segment: '' } as const satisfies TreeNode;
